export const BILLS_LIST = 'bills_payment/bills_list';
export const dummy = 'dummy';

export const GET_TOTAL_STATS = 'E_BILLS/get_total_stats';
export const GET_GRAPH_STATS = 'E_BILLS/get_graph_stats';

export const MODULE = 'DASHBOARD';
export const GET_YEAR_LIST = 'COLLECTION/GET_YEAR_LIST';

export const GET_COUNTS = `${MODULE}/get_count`;
export const GET_DATED_COUNTS = `${MODULE}/get_dated_count`;
export const GET_COLLECTION = `${MODULE}/get_collection`;

export const GET_ENEWS_COUNTS = `${MODULE}/get_enews_counts`

export const E_GOV = [
  'BPLS',
  'MVOPS',
  'CRIS',
  'SCMS',
  'MMS',
  'CDL',
  'PSA',
  'OHP',
  'RPTS',
  'BTAX',
];

export const COLORS = [
  '#A3B3F9',
  '#B1CDF8',
  '#BBE9FE',
  '#5272AA',
  '#84DAFF',
  '#8AA4F8',
  '#D9F5FA',
  '#8EEED7',
  '#7790CB',
  '#99BBFF',
];
export const E_BILLS_COLORS = [
  { name: 'Business Process Licensing (BPLS)', color: '#A3B3F9' },
  { name: 'Cedula (CDL)', color: '#8AA4F8' },
  { name: 'Birth Certificates (PSA)', color: '#D9F5FA' },
  { name: 'Occupational and Health (OHP)', color: '#8EEED7' },
  { name: 'Real Property Tax (RPTAX)', color: '#7790CB' },
  { name: 'Business Tax (BTAX)', color: '#99BBFF' },
];

export const E_BILLS = [
  { name: 'SSS', color: '#A3B3F9', value: 0 },
  { name: 'PAG-IBIG', color: '#8AA4F8', value: 0 },
  { name: 'Philhealth', color: '#D9F5FA', value: 0 },
  { name: 'Private Billers', color: '#8EEED7', value: 0 },
];

export const E_BILLS_SALES_TRANSACTIONS = [
  { name: 'Sales', color: '#7790CB', value: 0 },
  { name: 'Transactions', color: '#8EEED7', value: 0 },
];

export const E_BILLS_PAYMENTS = [
  { name: 'E-Bills Payments', color: '#7790CB', value: 0 },
];

export const E_COMMERCE = [
  { name: 'E-KITCHEN', color: '#A3B3F9', value: 0 },
  { name: 'E-MARKET', color: '#8AA4F8', value: 0 },
  { name: 'E-SHOPPING', color: '#D9F5FA', value: 0 },
  { name: 'E-DELIVERIES', color: '#8EEED7', value: 0 },
];

export const E_SERVICES = [
  { name: 'Amelioration', color: '#A3B3F9', value: 0 },
  { name: 'Job Hiring', color: '#8AA4F8', value: 0 },
  { name: 'Rentals', color: '#D9F5FA', value: 0 },
  { name: 'Loans', color: '#8EEED7', value: 0 },
];


export const E_NEWS = [
  { name: 'Non Video', color: '#A3B3F9', value: 0 },
  { name: 'Video', color: '#8AA4F8', value: 0 },
];

export const SERVICES_SELECT = [
  { label: 'E-GOVERNMENT', value: 'E-Government' },
  { label: 'E-BILLS PAYMENT', value: 'E-BILLS PAYMENT' },
  { label: 'E-COMMERCE', value: 'E-COMMERCE' },
  { label: 'E-SERVICE', value: 'E-SERVICE' },
];
